var render, staticRenderFns
import script from "./CInputGroup.vue?vue&type=script&lang=ts&"
export * from "./CInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acae650",
  null
  
)

export default component.exports